import { api } from '@cwd/lib/main';

export interface GlobalTemplateRef {
    TemplateId: string;
    Name: string;
    Description: string;
    ImageUrl: string;
}

export interface GlobalTemplate extends GlobalTemplateRef {
    EditableHtml: string;
    EditableCss: string;
}

export async function getGlobalTemplates(): Promise<GlobalTemplateRef[]> {
    return api.get('/Templates/Global?$expand=Tags&$select=Name,Description,ImageUrl,TemplateId,Tags');
}

export async function getTemplate(templateId: string): Promise<GlobalTemplate> {
    return api.get(`/BackOffice/Templates/${templateId}`);
}

export async function saveTemplate(template: GlobalTemplate): Promise<void> {
    return api.post('/BackOffice/Templates/', template);
}
